/**
 * /dashboard/change-requests — Change requests landing page (G7.5).
 *
 * Any authed tenant user reaches this — the backend handler scopes the
 * read (HR sees all; non-HR sees own). The HR vs employee toggle and
 * the row-level decision affordances live inside the components.
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/change-requests/page.tsx.
 * Swaps:
 *   - "use client" dropped
 *   - next/link Link → @tanstack/react-router Link
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { FileEdit, Plus } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { ChangeRequestList } from "@/components/change-requests/change-request-list";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/change-requests/")({
  component: ChangeRequestsRoute,
});

function ChangeRequestsRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <>
      <PageHeader
        title="Change Requests"
        description="Submit changes to your personal details and track HR's decision."
        actions={
          <Button asChild className="gap-1.5" data-testid="change-request-list-new-button">
            <Link to="/app/$tenantSlug/change-requests/new" params={{ tenantSlug }}>
              <Plus aria-hidden className="h-4 w-4" />
              New request
            </Link>
          </Button>
        }
      />
      <div className="flex items-center gap-2 text-sm text-muted-foreground sm:hidden">
        <FileEdit aria-hidden className="h-4 w-4" />
        <span>Address &amp; bank account workflows</span>
      </div>
      <ChangeRequestList />
    </>
  );
}
